export default __webpack_public_path__ + "72ac9659b6e7032efb6b91099bf586bc.svg";